// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module-checkbox {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background-color: var(--body-background);
  transition: 0.15s;
  padding: 0;
}

button.Checkbox-module-checkbox > svg {
  opacity: 0;
  fill: white;
}

.Checkbox-module-checked {
  background-color: var(--primary);
}

button.Checkbox-module-checkbox.Checkbox-module-checked > svg {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/input/Checkbox/Checkbox.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".checkbox {\n  height: 20px;\n  width: 20px;\n  border-radius: 5px;\n  background-color: var(--body-background);\n  transition: 0.15s;\n  padding: 0;\n}\n\nbutton.checkbox > svg {\n  opacity: 0;\n  fill: white;\n}\n\n.checked {\n  background-color: var(--primary);\n}\n\nbutton.checkbox.checked > svg {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export var checkbox = `Checkbox-module-checkbox`;
export var checked = `Checkbox-module-checked`;
export default ___CSS_LOADER_EXPORT___;
